import { secondarySearch } from "../../components/indexDB/indexDBStora";
import { comparePass } from "../encData";
import { encryptData, saveToCookie } from "../EncEmp";

const SECRET = process.env.REACT_APP_SECRET_KEY;
const PEPPER = process.env.REACT_APP_ENC;

export async function validationLoginStaff (username, password) {
    const result = {
        message: {
            head: "",
            body: ""
        },
        status: false,
    }
    if(!username || !password) {
        result.message.head = "no-data";
        result.message.body = "لا يوجد بيانات للتحقق منها رجاء ادخال الأسم المستخدم و كلمة المرور";
        return result;
    };
    
    const getUser = await secondarySearch("employees", "user", username);
    if(getUser.length === 0) {
        result.message.head = "undefined-employee";
        result.message.body = "اسم المستخدم او كلمة المرور خاطئة";
        return result;
    }
    
    const CheckPass = await comparePass(password + PEPPER, getUser[0].password);
    if(!CheckPass) {
        result.message.head = "undefined-employee";
        result.message.body = "اسم المستخدم او كلمة المرور خاطئة";
        return result;
    }
    if(!["cashier", "manager", "delivery"].includes(getUser[0].job)) {
        result.message.head = "illegal-employee";
        result.message.body = "هذا المستخدم غير مصرح بالدخول له";
        return result;
    } 
    const data = {
        // put code local employee
        code: getUser[0].code,
        name: getUser[0].fullName,
        role: getUser[0].job,
    }
    const encryptedObj = await encryptData(data, SECRET);
    saveToCookie("session_emp", encryptedObj);
    result.status = true
    return result;
}